import { formatDate } from '@/lib/format';
import { Button } from '@/components/ui/button';
import { RefreshCw } from 'lucide-react';
import { Pill, Empty, useFetch } from './shared';

export function DianAuditPanel() {
  const { data, loading, load } = useFetch('/admin/dian/audit-log?limit=100');
  const items = data?.items || [];
  return (
    <div className="space-y-3" data-testid="dian-audit-panel">
      <div className="flex justify-end">
        <Button size="sm" variant="ghost" className="rounded-none" data-testid="dian-audit-reload" onClick={load}>
          <RefreshCw className={`h-4 w-4 ${loading ? 'animate-spin' : ''}`} />
        </Button>
      </div>
      {items.length === 0 ? <Empty testId="dian-audit-empty">Sin acciones registradas.</Empty> : (
        <div className="overflow-x-auto border border-slate-200 bg-white p-3">
          <table className="w-full text-left" data-testid="dian-audit-table">
            <thead className="text-[10px] uppercase tracking-wider text-slate-500">
              <tr><th>Fecha</th><th>Acción</th><th>Actor</th><th>Objetivo</th><th>Resultado</th><th>Detalle</th></tr>
            </thead>
            <tbody>
              {items.map((a) => (
                <tr key={a.audit_id} className="border-t border-slate-100 text-sm" data-testid={`dian-audit-row-${a.audit_id}`}>
                  <td className="py-2 pr-3 text-xs">{formatDate(a.at)}</td>
                  <td className="py-2 pr-3 font-mono text-xs">{a.action}</td>
                  <td className="py-2 pr-3 text-xs">{a.actor}</td>
                  <td className="py-2 pr-3 font-mono text-xs">{a.target || '—'}</td>
                  <td className="py-2 pr-3"><Pill value={a.outcome} /></td>
                  <td className="py-2 font-mono text-[11px] text-slate-600 max-w-md truncate" title={JSON.stringify(a.details)}>
                    {JSON.stringify(a.details)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
